// app/src/components/SignUpPageMobilePart.tsx

import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../../contexts/AuthContext";
import SignUpPageMobilePartPanel2 from "./SignUpPageMobilePartPanel2";
import SignUpPageMobilePartPanel1 from "./SignUpPageMobilePartPanel1";
import { emitAnalytics, getTelemetryDeviceType } from '../../../services/telemetry/appInsights';

const SignUpPageMobilePart = () => {
	const { t, i18n } = useTranslation();
	const {
		userInfo,
		loadUserInfoFromLocalStorage,
	} = useAuthContext();

	// 👉 Panel 1 ouvert par défaut, Panel 2 fermé
	const [isPanel1Open, setIsPanel1Open] = useState(true);
	const [isPanel2Open, setIsPanel2Open] = useState(false);
	const hasTrackedPanel2Open = useRef(false);

	useEffect(() => {
		if (!userInfo?.contact?.email) {
			loadUserInfoFromLocalStorage('');
		}
	}, []);

	useEffect(() => {
		if (isPanel2Open && !hasTrackedPanel2Open.current) {
			hasTrackedPanel2Open.current = true;
			emitAnalytics('part_signup_panel2_opened', {
				entryRoute: '/part/signup',
				deviceType: getTelemetryDeviceType(),
				language: i18n.language,
			});
		}

		if (!isPanel2Open) {
			hasTrackedPanel2Open.current = false;
		}
	}, [isPanel2Open, i18n.language]);
	
	if (!userInfo?.contact?.email) {
		return <></>;
	}
	
	return (
		<div style={{ width: 390 }}>
			<div
				style={{
					width: 362,
					margin: '0 14px',
					background: '#F6F8FB',
					borderRadius: 10,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					paddingBottom: 22
				}}
			>
				<div
					style={{
						marginTop: 28,
						marginBottom: 10,
						width: 302,
						height: 52,
						top: 30,
						left: 31,
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div style={{
						color: '#004D71',
						fontSize: 22,
						fontWeight: 500
					}}>
						{t('homePagePart:title')}
					</div>
					
					<div style={{
						color: '#61AFA1',
						marginTop: 10,
						fontSize: 13,
						fontWeight: 500,
						textTransform: 'uppercase'
					}}>
						{t('homePagePart:subtitle')}
					</div>
				</div>

				<SignUpPageMobilePartPanel1
					isOpen={isPanel1Open}
					setIsOpen={setIsPanel1Open}
				/>
				<SignUpPageMobilePartPanel2
					isOpen={isPanel2Open}
					setIsOpen={setIsPanel2Open}
				/>

			</div>
			<div style={{ height: 20 }}></div>
		</div>
	);
};

export default SignUpPageMobilePart;
